import styled from "styled-components"

export const StyledItem = styled.li`
`
